/*
 *
 * ProfileLeader reducer
 *
 */

import { fromJS } from "immutable"
import {
  GET_PLANS_FAILED,
  GET_PLANS_SUCCESS,
  GET_PLANS_WATCHER,
  UPDATE_PHOTO_WATCHER,
  UPDATE_PHOTO_SUCCESS,
} from "./constants"

export const initialState = fromJS({
  loadingPlans: false,
  leader: [],
  divisions: [],
  loadingPhoto: false,
  team_leader: [],
})

function profileLeaderReducer(state = initialState, action) {
  switch (action.type) {
    case UPDATE_PHOTO_WATCHER:
      return state.set("loadingPhoto", true)

    case UPDATE_PHOTO_SUCCESS:
      return state.set("loadingPhoto", false)

    case GET_PLANS_WATCHER:
      return state.set("loadingPlans", true).set("team_leader", [])
    case GET_PLANS_SUCCESS:
      return state
        .set("leader", action.payload.leader)
        .set("loadingPlans", false)
        .set("divisions", action.payload.divisions)
        .set("team_leader", action.payload.team_leader)
    case GET_PLANS_FAILED:
      return state.set("loadingPlans", false)
    default:
      return state
  }
}

export default profileLeaderReducer
